<template>
  <div style="margin: 10px">
    <el-row>
      <el-col :spa="24">
        <el-card class="box-card">
          <h4 class="title">友情链接信息</h4>
          <el-form ref="form" :model="form" label-width="120px" :rules="rules">
            <el-form-item label="类型">
              <el-radio-group v-model="form.type">
                <el-radio :label="1">文字</el-radio>
                <el-radio :label="2">LOGO</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="标题" prop="title">
              <el-input v-model="form.title" style="width: 30%"></el-input>
            </el-form-item>
            <el-form-item label="URL" prop="url">
              <el-input v-model="form.url" style="width: 30%"></el-input>
            </el-form-item>
            <el-form-item label="LOGO" prop="pic">
              <!-- <el-input readonly v-model="form.pic" style="width:20%;float: left;"></el-input> -->
              <el-upload
                action=""
                :limit="1"
                drag
                list-type="picture-card"
                :file-list="logoList"
                :on-exceed="handleLogo"
                :on-remove="RemovePic"
                :before-upload="beforePic"
              >
                <i class="el-icon-picture-outline"></i>
                <br />
                <span class="uploadTip">将图片拖到此处，或点击上传</span>
              </el-upload>
              <span class="picTip"
                >封面图（支持JPG、JPEG、PNG图片大小限制120K）</span
              >
            </el-form-item>
            <el-form-item>
              <input
                type="button"
                @click="onReset"
                class="reset"
                value="重置"
              />
              <input
                type="button"
                @click="onSubmit('form')"
                class="submit"
                value="提交"
              />
            </el-form-item>
          </el-form>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import request from '../../assets/js/request.js'
import qs from 'qs'
export default {
  data () {
    return {
      form: {
        type: '',
        title: '',
        url: '',
        pic: '',
        id: ''
      },
      logoList: [],
      rules: {
        title: [{
          required: true,
          message: '请输入标题',
          trigger: 'blur'
        }],
        url: [{
          required: true,
          message: '请输入URL',
          trigger: 'blur'
        }],
        title: [{
          required: true,
          message: '请输入广告标题',
          trigger: 'blur'
        }],
        pic: [{
          required: true,
          message: '请上传图片',
          trigger: 'blur'
        }]
      }
    }
  },
  created () {
    if (this.$route.query.iden == 'update') {
      this.form.url = this.$route.query.rows.website
      this.form.title = this.$route.query.rows.title
      this.form.pic = this.$route.query.rows.logo
      this.form.type = this.$route.query.rows.type
      this.form.id = this.$route.query.rows.id
      this.logoList.push({ url: this.settings.apiBaseImg + this.$route.query.rows.logo })
    }
  },
  methods: {
    // 添加
    onSubmit (formName) {
      console.log('saaa')
      if (this.$route.query.iden == 'update') {
        this.onUpdate()
        return
      }
      this.loading = true
      var obj = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          obj.$http({
            method: 'post',
            url: 'api/v1/link/add',
            data: {
              title: this.form.title,
              type: this.form.type,
              website: this.form.url,
              logo: this.form.pic
            }
          }).then((res) => {
            if (res.data.status == 200) {
              obj.$message.success(res.data.message)
              this.$router.push({
                path: '/home/link'
              })
            } else {
              obj.$message.error(res.data.message)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 修改
    onUpdate () {
      console.log(this.form.pic)
      if (this.form.pic instanceof Array) {
        this.form.pic = this.form.pic.join('')
      }
      this.loading = true
      var obj = this
      obj.$http({
        method: 'post',
        url: 'api/v1/link/update',
        data: {

          id: this.form.id,
          title: this.form.title,
          type: this.form.type,
          website: this.form.url,
          logo: this.form.pic
        }
      }).then((res) => {
        if (res.data.status == 200) {
          console.log(res.data)
          obj.$message.success(res.data.message)
          this.$router.push({
            path: '/home/link'
          })
        } else {
          obj.$message.error(res.data.message)
        }
      })
    },
    // 重置
    onReset () {
      this.form.type = '',
        this.form.title = '',
        this.form.url = ''
      this.form.pic = ''
    },
    beforePic (file, fileList) {
      let objUrl = file
      let formData = new FormData()
      formData.append('file', objUrl)
      formData.append('uid', localStorage.getItem('uid'))
      var obj = this
      obj.$http({
        method: 'post',
        url: 'api/v1/link/upload',
        data: formData
      }).then((res) => {
        if (res.status == 200) {
          this.form.pic = res.data.data.url
          this.logoList = []
          this.logoList.push({ url: this.settings.apiBaseImg + res.data.data.url })
        } else {
          obj.$message.error(res.data.message)
        }
      })
    },
    handleLogo (files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    RemovePic () {
      this.form.pic = ''
    }
  }
}
</script>

<style scoped="scoped">
.title {
  margin-bottom: 40px;
}

/deep/ .el-input__inner {
  height: 30px;
}

.submit {
  float: right;
}

.reset {
  background: #ffffff;
  border: 1px solid #000000;
  box-shadow: 3px 4px 6px 0px rgba(0, 0, 0, 0.13);
  border-radius: 3px;
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/views/operate/linkUpdate.vue